import { render, staticRenderFns } from "./No05.vue?vue&type=template&id=f2105b0a&scoped=true"
import script from "./No05.vue?vue&type=script&lang=js"
export * from "./No05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2105b0a",
  null
  
)

export default component.exports